import { Injectable } from '@angular/core';
import { UsefulLinks } from './useful-links';
import { UsefulLink } from './useful-link';

@Injectable()
export class UsefulLinksService {
	private list: UsefulLinks;
	private socialList: UsefulLinks;

	constructor() {
		this.list = {
			usefullinksList: [
				{
					title: 'Προστασία Δεδομένων Προσωπικού Χαρακτήρα',
					url: 'https://www.nbg.gr/-/jssmedia/Files/Footer/privacy_statement',
				},
				//{
				//    title: 'Γενικές πληροφορίες',
				//    url: './general-information'
				//},
				//{
				//    title: 'Εγχειρίδια - οδηγίες',
				//    url: './manuals'
				//},
				{
					title: 'Συμβατότητα με browsers',
					url: './browser-compatibility',
				},
			],
		};
		this.socialList = {
			usefullinksList: [
				{
					title: 'Facebook',
					url: 'https://www.facebook.com/nationalbankofgreece/',
				},
				{
					title: 'Twitter',
					url: 'https://twitter.com/NationalBankGR',
				},
				{
					title: 'YouTube',
					url: 'https://www.youtube.com/channel/UCAwPZIUpdP3aIQlfw4bETLQ',
				},
				{
					title: 'LinkedIn',
					url: 'https://www.linkedin.com/company/national-bank-of-greece/',
				},
				{
					title: 'Email',
					url: 'https://www.nbg.gr/el/footer/epikoinwnia',
				},
			],
		};
	}

	get links(): UsefulLink[] {
		return this.list.usefullinksList;
	}
	get socialLinks(): UsefulLink[] {
		return this.socialList.usefullinksList;
	}

	private emailUrl(): string {
		return;
	}
}
